import { BookOpen, Clock, ShieldAlert, Target } from 'lucide-react';
import { Button } from '@/components/ui/button';

export default function WelcomeStep({ module, onContinue }: {
  module: { displayLabel: string; displayOrder: string; learningOutcome: string; estimatedMinutes: number; safetyWarnings: string; practicalAssessmentItems: string };
  onContinue: () => void;
}) {
  return (
    <div className="space-y-4">
      <div className="text-center py-4">
        <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-3">
          <BookOpen className="w-8 h-8 text-primary" />
        </div>
        <h1 className="text-xl font-bold text-foreground">{module.displayLabel}</h1>
        <p className="text-sm text-muted-foreground mt-1">{module.displayOrder}</p>
        {module.estimatedMinutes > 0 && (
          <p className="text-xs text-muted-foreground flex items-center gap-1 justify-center mt-2">
            <Clock className="w-3 h-3" /> ~{module.estimatedMinutes} minutes
          </p>
        )}
      </div>

      {module.learningOutcome && (
        <div className="bg-primary/5 border border-primary/20 rounded-xl p-4">
          <div className="flex items-start gap-2">
            <Target className="w-4 h-4 text-primary mt-0.5 shrink-0" />
            <div>
              <p className="text-xs font-bold text-primary uppercase tracking-wider mb-1">What You Will Learn</p>
              <p className="text-sm text-foreground whitespace-pre-wrap leading-relaxed">{module.learningOutcome}</p>
            </div>
          </div>
        </div>
      )}

      {module.safetyWarnings && (
        <div className="bg-destructive/10 border border-destructive/30 rounded-xl p-4 flex gap-3">
          <ShieldAlert className="w-5 h-5 text-destructive shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-bold text-destructive mb-1">⚠ Safety Warning</p>
            <p className="text-sm text-foreground whitespace-pre-wrap leading-relaxed">{module.safetyWarnings}</p>
          </div>
        </div>
      )}

      {module.practicalAssessmentItems && (
        <div className="border border-border rounded-xl p-4">
          <p className="text-xs font-bold text-muted-foreground uppercase tracking-wider mb-2">Practical Assessment Areas</p>
          <p className="text-sm text-foreground whitespace-pre-wrap leading-relaxed">{module.practicalAssessmentItems}</p>
        </div>
      )}

      <Button onClick={onContinue} className="w-full h-12 text-base">
        Start Learning
      </Button>
    </div>
  );
}
